export default {
  namespaced: true,
  actions: {
  },
  mutations: {
    goodsId(state, value) {
      state.goodsId = value
    },
    goodsPrice(state, value) {
      state.goodsPrice = value
    },
    orderOwner(state, value) {
      state.orderOwner = value
    },
    ownerAddr(state, value) {
      state.ownerAddr = value
    },
    goodsType(state, value) {
      state.goodsType = value
    },
    sale(state, value) {
      state.goodsId = value.goodsId
      state.goodsPrice = value.goodsPrice
      state.orderOwner = value.orderOwner
      state.ownerAddr = value.ownerAddr
      state.goodsType = value.goodsType
    },
  },
  state: {
    goodsId: '', //购买商品ID
    goodsPrice: '', //商品价格
    goodsType: '', //商品类型
    orderOwner: '', //订单拥有人地址
    ownerAddr: '', //商品拥有人地址
  },
  getters: {
  },
}